import * as angular from "angular";
import {History} from "../models/history.model";
import {Column} from "../models/column.model";

const HISTORY_INIT_DATA = "history";

export class MatchHistoryController {
    history: History[];
    columns: Column[];
    
    /* @ngInject */
    constructor(
        public $route: angular.route.IRouteService,
        private $routeParams: { districtId: string }
    ) {}

    $onInit() {
        this.columns = [
            {headerName: "Matched Date", field: "matched", initialSort: "DESC", cellRenderer: this.renderHtmlForMatchedDate},
            {headerName: "User", field: "user.name"},
            {headerName: "Naviance School", field: "navianceSchoolDisplay", suppressSorting: true, multiLine: true},
            {headerName: "Clever School", field: "cleverSchoolDisplay", suppressSorting: true, multiLine: true},
            {headerName: "Status", field: "status"}
        ];
        this.history = this.$route.current.locals[HISTORY_INIT_DATA];
    }

    private renderHtmlForMatchedDate = (params) => {
        params.$scope.vm = this;
        return `
            <span>{{ data.matchedDate }}</span>
        `;
    }

    getLandingUrl() {
        return `#/${this.$routeParams.districtId}`;
    }

    noHistoryMessage() {
        return !this.history || this.history.length === 0;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/match-history/match-history.controller.ts